import environment from '../../environment';
import StoresAfterSalesControl from './StoresAfterSalesControl';
import worldMap from '../../core/map';

export class NetworkfterSalesControl extends StoresAfterSalesControl {
    constructor() {
        const options = {
            name: 'NetworkAfterSales',
            context: 'LAYER_AFTER_SALES_NETWORK',
        };

        super(options);
    }

    static getInstance() {
        if (!NetworkfterSalesControl._instance) {
            NetworkfterSalesControl._instance = new NetworkfterSalesControl();
        }

        return NetworkfterSalesControl._instance;
    }
}

export default NetworkfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/NetworkAfterSalesControl.js